import React from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, ButtonGroup } from 'react-bootstrap'

export default function DownloadLink({ intake }) {
  const clientId = useSelector(state => state.client.id);
  const authToken = useSelector(state => state.authentication.token);

  let url = `${process.env.REACT_APP_API_URL}/api/v2/provider/${clientId}/intake/${intake.intakeId}/questionnaire/${intake.questionnaire.id}/download`;
  url += `?access_token=${authToken}`;

  return <Dropdown as={ButtonGroup}>
    <Dropdown.Toggle variant="outline-primary btn-sm">
      Download
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item href={`${url}&type=word`}>Word Document</Dropdown.Item>

      {parseInt(clientId) === 1 &&
        <Dropdown.Item href={`${url}&type=partice_parters`}>Practice Partners</Dropdown.Item>
      }
    </Dropdown.Menu>
  </Dropdown>
}